import { detect } from 'detect-browser';

import LoggingService from '../services/LoggingService';
import { getPersistentState } from './storage';

// eslint-disable-next-line @typescript-eslint/ban-types
let logger: LoggingService;
const browserData = detect();

export function formatError(error: unknown): unknown {
	if (error instanceof Error) {
		return error.toString();
	}
	return error;
}

export function logError(
	error: Error | string,
	errorInfo?: unknown
): Promise<void> {
	if (!logger) {
		logger = new LoggingService();
	}

	const { sessionId } = getPersistentState();

	return logger.log({
		sessionId,
		error: formatError(error),
		stack: error instanceof Error && error.stack ? error.stack : undefined,
		errorInfo,
		url: window.location.href,
		clientVersion: VERSION_NUMBER,
		windowSize: `${window.innerWidth} x ${window.innerHeight}px`,
		browser: browserData && browserData.name ? browserData.name : undefined,
		browserVersion:
			browserData && browserData.version ? browserData.version : undefined,
		os: browserData && browserData.os ? browserData.os : undefined,
	});
}
